<template>
  <div :class="className" :id="id" :style="{ height: height, width: width }" />
</template>

<script>
// import resize from "./mixins/resize";

export default {
  name: "HomeBottomBar",
  // mixins: [resize],
  props: {
    className: {
      type: String,
      default: "chart"
    },
    id: {
      type: String,
      default: "CesuoPinglun"
    },
    width: {
      type: String,
      default: "200px"
    },
    height: {
      type: String,
      default: "200px"
    },
    chartData: {
      type: Object,
        default() {
            return null;
        }
    }
  },
  data() {
    return {
      chart: null,
      option: null,
      curtab: 0
    };
  },
    mounted() {
        if (this.chartData) {
            this.initChart();
        }
    },
    beforeDestroy() {
        if (!this.chart) {
            return;
        }
        this.chart.dispose();
        this.chart = null;
    },
    watch: {
        chartData() {
            if (this.chart) {
                this.chart.dispose();
                this.chart = null;
            }
            this.initChart();
        }
    },
  methods: {
    initChart() {
      this.option = {
       /* title: {
          text: "游客评分排名",
          x: "center",
          y: "top",
          textAlign: "left",
          // x:'center',
          // y:'top',
          // textAlign:'center'
          textStyle: {
            color: "#cbeeff"
          }
        },*/
        grid: {
          top: "20%",
          bottom: "0%",
          /* left: 20,
          right: 20,*/
          right: "8%",
          containLabel: true
        },
        tooltip: {
          trigger: "axis",
          // triggerOn: "none",
          confine: true,
          textStyle: {
            color: "#cbeeff"
          },
          axisPointer: {
            type: "cross",
            crossStyle: {
              color: "#999"
            }
          }
        },
        toolbox: {
          // feature: {
          //   magicType: { show: true, type: ['line', 'bar'] },
          //   restore: { show: true }
          // }
        },
        legend: {
          left: "center",
          data: this.chartData.legendList,
          icon: "rect",
          // left: "8%",
          itemGap: 12,
          itemWidth: 12,
          itemHeight: 12,
          textStyle: {
            fontSize: 14,
            color: "#cbeeff"
          },
            top: "0%",
            bottom: 20,
        },
        xAxis: [
          {
            type: "category",
            data: this.chartData.nameList,
            axisPointer: {
              type: "shadow"
            },
            axisLine: {
              lineStyle: {
                color: "#132847"
              }
            },
            axisLabel: {
              color: "#cbeeff",
              interval: 0,
              rotate: 40
            },
            axisTick: {
              show: false
            }
          }
        ],
        yAxis: [
          {
            type: "value",
            // name: "",
            min: 0,
            max: 10,
            interval: 2,
            axisLabel: {
              color: "#cbeeff",
              formatter: "{value}"
            },
            axisLine: {
              show: false
            },
            splitLine: {
              show: false
            },
            axisTick: {
              show: false
            }
          }
        ],
        series: [
          {
            name: "景观",
            type: "line",
            smooth: true,
            symbol: "none",
            data: [
              8.625726,
              8.123456,
              9.123456,
              9.625726,
              8.123456,
              8.625726,
              8.123456,
              9.123456,
              9.625726,
              8.123456,
              8.654321
            ],
            markLine: {
              symbol: "none",
              lineStyle: {
                normal: {
                  opacity: 0.7
                }
              },
              // data: [
              //   {
              //     yAxis: 50
              //   }
              // ]
            },
            itemStyle: {
              normal: {
                color: "#D5C258"
              }
            },
              lineStyle: {
                  normal: {
                      color: "#D5C258",
                      width: 2
                  }
              },
            barWidth: 10
          },
          {
            name: "服务",
            type: "line",
            smooth: true,
            symbol: "none",
            data: [
              3.510484,
              4.510484,
              5.510484,
              6.510484,
              3.510484,
              4.510484,
              5.510484,
              6.510484,
              3.510484,
              4.510484,
              5.510484,
              6.510484
            ],
            // symbol: "none",
            itemStyle: {
              normal: {
                color: "#EFA64A"
              }
            },
            lineStyle: {
              normal: {
                color: "#EFA64A",
                width: 2
              }
            }
          },
          {
            name: "消费",
            type: "line",
            smooth: true,
            symbol: "none",
            data: [
              8.625726,
              7.123456,
              8.123456,
              7.625726,
              8.123456,
              7.625726,
              8.123456,
              7.123456,
              8.625726,
              7.123456,
              8.654321
            ],
            // symbol: "none",
            itemStyle: {
              normal: {
                color: "#EA6031"
              }
            },
            lineStyle: {
              normal: {
                color: "#EA6031",
                width: 2
              }
            }
          },
          {
            name: "配套",
            type: "line",
            smooth: true,
            symbol: "none",
            data: [
              6.601532,
              8.123456,
              6.601532,
              8.123456,
              6.601532,
              8.123456,
              6.601532,
              8.123456,
              6.601532,
              8.123456,
              6.601532,
              8.123456
            ],
            // symbol: "none",
            itemStyle: {
              normal: {
                color: "#D03626"
              }
            },
            lineStyle: {
              normal: {
                color: "#D03626",
                width: 2
              }
            }
          }
        ]
      };

      this.chart = this.$echarts.init(document.getElementById(this.id));
      this.chart.setOption(this.option);
    }
    // changeBar() {
    //   this.curtab = 0;
    //   for (let i = 0; i < this.option.series.length; i++) {
    //     this.option.series[i].type = "bar";
    //   }
    //   this.option.series[3].data = [];
    //   this.chart.setOption(this.option);
    // },
    // changeLine() {
    //   this.curtab = 0;
    //   for (let i = 0; i < this.option.series.length; i++) {
    //     this.option.series[i].type = "line";
    //   }
    //   this.chart.setOption(this.option);
    // }
  }
};
</script>
<style scoped lang="less">
.home-bottom-bar {
  width: 100%;
  height: 100%;
  position: relative;
  .tab-group {
    height: 0.3rem;
    line-height: 0.3rem;
    position: absolute;
    z-index: 999;
    right: 0.15rem;
    top: 0;
    color: @base-text-color;
    > div {
      float: left;
      padding-right: 0.15rem;
      position: relative;
      > div {
        float: left;
      }
      .icon {
        width: 0.3rem;
        height: 0.3rem;
        img {
          width: 100%;
          height: 100%;
          display: block;
        }
      }
      .text {
        cursor: pointer;
      }
      ul {
        width: 100%;
        position: absolute;
        left: 0;
        top: 0.3rem;
        li {
          width: 100%;
          height: 0.22rem;
          line-height: 0.22rem;
          border: 1px solid #0c6398;
          background: rgba(0, 183, 247, 0.2);
          cursor: pointer;
        }
      }
    }
  }
}
</style>
